import { getLanguageSource } from '../../common/languageUtils'
import { LanguageConfigSource, MeetingLanguage, RoomSessionLanguageConfig } from '../../models/Room'

export const getLanguageSettingDescription = (
  languageConfig: RoomSessionLanguageConfig,
  getLabel: (language?: MeetingLanguage | null) => string,
): string | null => {
  switch (languageConfig.source) {
    case LanguageConfigSource.NO_CLIENTS_ACCOUNT_CONFIG:
      return `Clients languages not set. Meeting will be processed in ${getLabel(languageConfig.language)}${getLanguageSource(languageConfig)}.`
    case LanguageConfigSource.CALCULATED_MAJORITY:
    case LanguageConfigSource.CALCULATED_ACCOUNT_CONFIG:
      return `Clients have different languages. Meeting will be processed in ${getLabel(languageConfig.language)}${getLanguageSource(languageConfig)}.`
    case LanguageConfigSource.CALCULATED_UNAMBIGUOUS:
      return `All clients have ${getLabel(languageConfig.language)} set in their profiles.`
    default:
      return null
  }
}

export const getLanguageTooltipDescription = (
  languageConfig: RoomSessionLanguageConfig,
  getLabel: (language?: MeetingLanguage | null) => string,
): string | null => {
  if (languageConfig.source === LanguageConfigSource.MANUAL) {
    return null
  }

  if (languageConfig.language === MeetingLanguage.AUTO_DETECT) {
    return 'AI Assistant will detect the spoken language during the meeting.'
  }

  return getLanguageSettingDescription(languageConfig, getLabel)
}

export const getLanguageSettingPastDescription = (
  languageConfig: RoomSessionLanguageConfig,
  getLabel: (language?: MeetingLanguage | null) => string,
): string | null => {
  switch (languageConfig.source) {
    case LanguageConfigSource.NO_CLIENTS_ACCOUNT_CONFIG:
    case LanguageConfigSource.CALCULATED_MAJORITY:
    case LanguageConfigSource.CALCULATED_ACCOUNT_CONFIG:
    case LanguageConfigSource.CALCULATED_UNAMBIGUOUS:
      return `${getLabel(languageConfig.language)}${getLanguageSource(languageConfig)} was determined based on clients' languages.`
    case LanguageConfigSource.TRANSCRIPT_AUTO_DETECT:
      return `AI Assistant detected ${getLabel(languageConfig.language)} as the meeting language`
    case LanguageConfigSource.MANUAL:
      return `${getLabel(languageConfig.language)} was manually set as meeting language`
    default:
      return null
  }
}
